import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WebCamModule } from 'ack-angular-webcam';

import { QuizzQuestionSelfieOnWebPage } from './quizz-question-selfie-on-web';

@NgModule({
  declarations: [
    QuizzQuestionSelfieOnWebPage,
  ],
  imports: [
    IonicPageModule.forChild(QuizzQuestionSelfieOnWebPage),
    WebCamModule,
  ],
  exports: [
    QuizzQuestionSelfieOnWebPage
  ]
})
export class QuizzQuestionSelfieOnWebPageModule { }



// WEBPACK FOOTER //
// ./src/pages/quizz-question-selfie-on-web/quizz-question-selfie-on-web.module.ts